export const defaultFill = '#606060'
